import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonical, type = 'website', keywords }) => {
  const siteName = 'PDF Studio Pro: Edit & Sign PDFs';
  const defaultDesc = 'PDF Studio Pro is the fastest PDF editor and converter. Easily edit text, annotate documents, add digital signatures, merge multiple files, and convert PDFs to JPG or Word. Ideal for business & students.';
  const desc = description || defaultDesc;
  const pageTitle = title ? `${title} | ${siteName}` : siteName;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
};

export default SEO;
